const isFacetSearchParam = (paramKey) => {
  const pattern = /^(ge_|le_|gt_|lt_|f\.)[a-zA-Z0-9][a-zA-Z0-9 ]*\|[a-zA-Z0-9][a-zA-Z0-9]*$/;
  const pattern2 = /^(ge_|le_|meta_)[a-zA-Z0-9]*$/;
  return !!paramKey.match(pattern) || !!paramKey.match(pattern2);
};

export default isFacetSearchParam;
